import {inject, Injectable, signal} from '@angular/core';
import {TelegramService} from "./telegram.service";
import {TelegramAccountImagesService} from "./telegram-account-images.service";
import {TelegramAccountsService} from "./telegram-accounts.service";
import {UserChatQueryParams} from "../types/telegram-page.types";
import {TelegramModalsService} from "./telegram-modals.service";
import {TelegramChatsService} from "./telegram-chats.service";

@Injectable({
  providedIn: 'root'
})
export class TelegramChatModalService {
  private telegramModalsService: TelegramModalsService = inject(TelegramModalsService);
  private telegramService: TelegramService = inject(TelegramService);
  private telegramAccountImagesService: TelegramAccountImagesService = inject(TelegramAccountImagesService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);
  private telegramChatsService: TelegramChatsService = inject(TelegramChatsService);

  private _chatId = signal<number>(0);
  public chatId = this._chatId.asReadonly();

  public async getUserChatQueryParams(recordCalendarId: number): Promise<UserChatQueryParams | null> {
    return await this.telegramModalsService.getTelegramChat(recordCalendarId)
      .catch(() => null);
  }

  public async getAccount(accountId: string): Promise<void> {
    const accounts = await this.telegramService.getAccounts();
    this.telegramAccountImagesService.loadAccountPhotos(accounts);
    const account = accounts.find(i => i.accountId === accountId)!;
    this.telegramAccountsService.setSelectedAccount(account)
  }

  public async getChatId(userChatQueryParams: UserChatQueryParams): Promise<number> {
    return await this.telegramService.getUserChat(userChatQueryParams).catch(() => 0);
  }

  public async getChat(userChatQueryParams: UserChatQueryParams): Promise<void> {
    const chatId = await this.getChatId(userChatQueryParams);
    this._chatId.set(chatId);
    this.telegramChatsService.setChat(chatId);
  }
}
